import Section from '@components/common/Section/Section'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import { FC } from 'react'
import FaqAccordion from './FaqAccordion/FaqAccordion'
import FaqFilter from './FaqFilter/FaqFilter'
import styles from './FaqModule.module.scss'
import cn from 'clsx'

type FaqModuleProps = {
  faqSections?: FaqSection[]
  expandableSections?: boolean
  enableFilter?: boolean
}

export interface FaqSection {
  title: string
  faqSubSections: FaqSubSection[]
}

export interface FaqSubSection {
  title: string
  body: string
}

const FaqModule: FC<FaqModuleProps> = ({
  faqSections,
  expandableSections,
  enableFilter,
}) => {
  return faqSections ? (
    <Section>
      {enableFilter && <FaqFilter sections={faqSections} />}

      <div className={styles.outerSectionContainer}>
        <div className={styles.sectionContainer}>
          {faqSections &&
            !expandableSections &&
            faqSections.map((section) => (
              <div id={section.title} key={section.title}>
                {section.title && (
                  <div className={styles.sectionTitle}>
                    <h1 className="headerTwo">{section.title}</h1>
                  </div>
                )}

                <div className={styles.subSectionContainer}>
                  {section.faqSubSections &&
                    section.faqSubSections.map((subsection) => (
                      <div className={styles.subSection} key={subsection.title}>
                        <div
                          className={cn(styles.subSectionTitle, 'headerTwo')}
                        >
                          {subsection.title}
                        </div>
                        <div className={styles.subSectionLine} />
                        <TrustedHtml
                          className={styles.subSectionContent}
                          html={subsection.body}
                        />
                      </div>
                    ))}
                </div>
              </div>
            ))}

          {faqSections &&
            expandableSections &&
            faqSections.map((section) => (
              <div id={section.title} key={section.title}>
                <div className={styles.subSectionContainer}>
                  <div className={styles.subSection}>
                    <div className={cn(styles.subSectionTitle, 'headerTwo')}>
                      {section.title}
                    </div>
                    <div className={styles.subSectionLine} />
                    {section.faqSubSections &&
                      section.faqSubSections.map((subsection) => (
                        <FaqAccordion
                          key={subsection.title}
                          section={subsection}
                        />
                      ))}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </Section>
  ) : (
    <></>
  )
}

export default FaqModule
